import iconQuit from '@assets/images/static/icon-quit.png';
import iconValid from '@assets/images/static/icon-valid.png';
import React from 'react';
import { styled } from 'styled-components';
//import { classic } from '~/themes';

type IProps = {
  children: React.ReactNode;
  onClick?: () => void;
  selected: boolean;
  isLastInList?: boolean;
  $submitted: boolean;
  status?: 'good' | 'wrong' | 'warning' | 'neutral';
};

type TProps = IProps;

export function FriseItem({
  selected,
  status,
  $submitted,
  onClick,
  isLastInList,
  children,
}: TProps) {
  return (
    <Wrapper>
      <Container $submitted={$submitted} onClick={onClick} selected={selected}>
        <SDivBarre $isLast={isLastInList} />
        <SDivItem $status={status} $submitted={$submitted} selected={selected}>
          <SDivPointWrapper>
            <SDivPoint
              $status={status}
              $submitted={$submitted}
              selected={selected}
            >
              {$submitted && status === 'good' && (
                <img src={iconValid} alt="" />
              )}
              {$submitted && status === 'wrong' && (
                <img src={iconQuit} alt="" />
              )}
            </SDivPoint>
          </SDivPointWrapper>
          <SSpan>{children}</SSpan>
        </SDivItem>
      </Container>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  width: 100%;
`;

const Container = styled.div<{ selected?: boolean; $submitted: boolean }>`
  align-items: center;
  display: flex;
  height: 100px;
  justify-content: flex-start;
  margin: 0 20px;
  position: relative;
  pointer-events: ${({ $submitted }) => ($submitted ? 'none' : 'auto')};
  width: 100%;

  @media screen and (max-width: 415px) {
    height: 70px;
  }

  @media screen and (max-height: 600px) {
    height: 70px;
  }
`;
// ${classic.token?.colorWhite}
const SDivBarre = styled.div<{ $isLast?: boolean }>`
  background-color: ${({ $isLast }) => ($isLast ? 'transparent' : `#f7f7f7`)};
  height: 100%;
  left: -3px;
  top: 0;
  position: absolute;
  width: 6px;
`;
const SDivPointWrapper = styled.div`
  align-items: center;
  background-color: #f7f7f7;
  box-shadow:
    inset 0 6.6px 6.6px 0 rgba(255, 255, 255, 0.35),
    inset 0 -6.6px 6.6px 0 rgba(0, 0, 0, 0.4),
    0 9.9px 13.2px 0 rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 40px;
  margin-right: 20px;
  width: 40px;

  @media screen and (max-width: 415px) {
    height: 30px;
    margin-right: 10px;
    width: 30px;
  }

  @media screen and (max-height: 600px) {
    height: 30px;
    margin-right: 10px;
    width: 30px;
  }
`;

const SDivPoint = styled.div<{
  selected: boolean;
  $submitted: boolean;
  $status?: 'good' | 'wrong' | 'warning' | 'neutral';
}>`
  border-radius: 50%;
  box-shadow:
    inset 0 2px 2px 0 rgba(255, 255, 255, 0.35),
    inset 0 -2px 2px 0 rgba(0, 0, 0, 0.4),
    0 3px 4px 0 rgba(0, 0, 0, 0.25);

  background-color: ${({ $submitted, selected, $status }) => {
    if (!$submitted) {
      return selected ? '#009fc3' : '#D5D5D5';
    } else {
      if ($status === 'good') return '#14b15c';
      if ($status === 'wrong') return '#dd4848';
      if ($status === 'warning') return '#dd4848';
      return '#D5D5D5';
    }
  }};

  height: 28px;
  position: relative;
  width: 28px;

  @media screen and (max-width: 415px) {
    height: 22px;
    width: 22px;
  }

  @media screen and (max-height: 600px) {
    height: 22px;
    width: 22px;
  }
  img {
    left: 0;
    top: 0;
    height: 100%;
    object-fit: contain;
    position: absolute;
    width: 100%;
  }
`;

const SDivItem = styled.button<{
  selected: boolean;
  $submitted: boolean;
  $status?: 'good' | 'wrong' | 'warning' | 'neutral';
}>`
  align-items: center;
  background-color: transparent;

  color: ${({ $submitted, selected, $status }) => {
    if (!$submitted) {
      return selected ? '#009fc3' : '#4d4d4f';
    } else {
      if ($status === 'good') return '#14b15c';
      if ($status === 'wrong') return '#dd4848';
      if ($status === 'warning') return '#dd4848';
      return '#4d4d4f';
    }
  }};

  cursor: pointer;
  left: -20px;
  display: flex;
  justify-content: flex-start;
  position: absolute;
  top: -20px;
  width: 100%;

  @media screen and (max-width: 415px) {
    left: -15px;
    top: -15px;
  }

  @media screen and (max-height: 600px) {
    left: -15px;
    top: -15px;
  }

  &:focus {
    outline: 0;
    color: #29292a;
    & > span {
      font-size: 1.1rem;
    }
  }
`;

const SSpan = styled.span`
  font-size: 1rem;
  font-weight: bold;
`;
